;(function () {
  'use strict'

  var INSTANCES = new WeakMap()

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
  }

  function measureHeaderOffset() {
    var header =
      document.querySelector('.section-header') ||
      document.querySelector('sticky-header') ||
      document.querySelector('#shopify-section-header') ||
      document.querySelector('header')
    if (!header) return 0
    var rect = header.getBoundingClientRect()
    return Math.max(0, Math.round(rect.bottom || header.offsetHeight || rect.height || 0))
  }

  function measureVh() {
    var vv = window.visualViewport
    var h = vv && vv.height ? vv.height : window.innerHeight
    return Math.max(320, Math.round(h))
  }

  function playVideo(el) {
    if (!el || el.tagName !== 'VIDEO') return
    el.muted = true
    el.defaultMuted = true
    el.setAttribute('muted', '')
    el.playsInline = true
    var p = el.play()
    if (p && p.catch) p.catch(function () {})
  }

  function HeroVideo(root) {
    this.root = root
    this.destroyed = false
    this.track = root.querySelector('[data-hss-track]')
    this.slides = root.querySelectorAll('[data-hss-slide]')
    this.dots = root.querySelectorAll('[data-hss-dot]')
    this.index = 0
    this.locked = false
    this.isMobile = window.matchMedia('(max-width: 749px)').matches
    this.onResize = this.onResize.bind(this)
    this.onWheel = this.onWheel.bind(this)
    this.onScroll = this.onScroll.bind(this)
    this.onMode = this.onMode.bind(this)

    this.applyMetrics()
    this.bind()
    this.setIndex(0, true)
    if (!prefersReducedMotion()) this.playIndex(0)
  }

  HeroVideo.prototype.applyMetrics = function () {
    var header = measureHeaderOffset()
    var vh = measureVh()
    this.root.style.setProperty('--hss-header-offset', header + 'px')
    this.root.style.setProperty('--hss-vh', vh + 'px')
  }

  HeroVideo.prototype.slideHeight = function () {
    return (this.track && this.track.clientHeight) || measureVh()
  }

  HeroVideo.prototype.bind = function () {
    var self = this
    window.addEventListener('resize', this.onResize, { passive: true })
    if (window.matchMedia) {
      this.mq = window.matchMedia('(max-width: 749px)')
      if (this.mq.addEventListener) this.mq.addEventListener('change', this.onMode)
      else if (this.mq.addListener) this.mq.addListener(this.onMode)
    }
    if (this.track && this.slides.length > 1) {
      this.track.addEventListener('wheel', this.onWheel, { passive: false })
      this.track.addEventListener('scroll', this.onScroll, { passive: true })
    }
    this.dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        self.goTo(i)
      })
    })
  }

  HeroVideo.prototype.onMode = function () {
    this.isMobile = window.matchMedia('(max-width: 749px)').matches
    this.applyMetrics()
    this.goTo(this.index, true)
    this.playIndex(this.index)
  }

  HeroVideo.prototype.onResize = function () {
    if (this.destroyed) return
    this.isMobile = window.matchMedia('(max-width: 749px)').matches
    this.applyMetrics()
    this.goTo(this.index, true)
  }

  HeroVideo.prototype.onScroll = function () {
    if (this.locked || !this.track) return
    var h = this.slideHeight()
    if (!h) return
    var i = Math.round(this.track.scrollTop / h)
    this.setIndex(i, false)
  }

  HeroVideo.prototype.onWheel = function (e) {
    if (this.destroyed || this.slides.length < 2) return
    if (this.isMobile) return
    var dy = e.deltaY
    if (!dy) return
    var last = this.slides.length - 1
    if (this.locked) {
      e.preventDefault()
      return
    }
    if (this.index >= last && dy > 0) {
      window.scrollBy(0, dy)
      e.preventDefault()
      return
    }
    if (this.index <= 0 && dy < 0) {
      return
    }
    var next = this.index + (dy > 0 ? 1 : -1)
    if (next < 0 || next > last) return
    e.preventDefault()
    this.goTo(next)
  }

  HeroVideo.prototype.goTo = function (i, instant) {
    if (!this.track || !this.slides.length) return
    i = Math.max(0, Math.min(this.slides.length - 1, i))
    var h = this.slideHeight()
    this.locked = true
    this.track.scrollTo({ top: i * h, behavior: instant ? 'auto' : 'smooth' })
    this.setIndex(i, true)
    var self = this
    clearTimeout(this.lockTimer)
    this.lockTimer = setTimeout(function () {
      self.locked = false
    }, instant ? 50 : 720)
  }

  HeroVideo.prototype.setIndex = function (i, forcePlay) {
    i = Math.max(0, Math.min(this.slides.length - 1, i || 0))
    var changed = i !== this.index
    this.index = i
    this.dots.forEach(function (dot, idx) {
      dot.classList.toggle('is-active', idx === i)
    })
    this.slides.forEach(function (slide, idx) {
      slide.classList.toggle('is-active', idx === i)
    })
    if (changed || forcePlay) this.playIndex(i)
  }

  HeroVideo.prototype.playIndex = function (i) {
    var self = this
    var reduce = prefersReducedMotion()
    this.slides.forEach(function (slide, idx) {
      var videos = slide.querySelectorAll('video')
      videos.forEach(function (v) {
        if (idx === i && !reduce) playVideo(v)
        else v.pause()
      })
    })
    if (this.isMobile) {
      var slide = this.slides[i]
      if (!slide) return
      var mob = slide.querySelector('[data-hss-video="mobile"]')
      var desk = slide.querySelector('[data-hss-video="desktop"]')
      if (mob && desk && desk.tagName === 'VIDEO') desk.pause()
    }
  }

  HeroVideo.prototype.destroy = function () {
    this.destroyed = true
    window.removeEventListener('resize', this.onResize)
    if (this.track) {
      this.track.removeEventListener('wheel', this.onWheel)
      this.track.removeEventListener('scroll', this.onScroll)
    }
    if (this.mq) {
      if (this.mq.removeEventListener) this.mq.removeEventListener('change', this.onMode)
      else if (this.mq.removeListener) this.mq.removeListener(this.onMode)
    }
    this.slides.forEach(function (slide) {
      slide.querySelectorAll('video').forEach(function (v) {
        v.pause()
      })
    })
  }

  function mount(root) {
    if (!root || INSTANCES.has(root)) return
    INSTANCES.set(root, new HeroVideo(root))
  }

  function unmount(root) {
    var inst = INSTANCES.get(root)
    if (inst) {
      inst.destroy()
      INSTANCES.delete(root)
    }
  }

  function bootAll() {
    document.querySelectorAll('[data-hss]').forEach(mount)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll)
  } else {
    bootAll()
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root =
      e.target.querySelector('[data-hss]') ||
      (e.target.matches && e.target.matches('[data-hss]') ? e.target : null)
    if (root) mount(root)
  })
  document.addEventListener('shopify:section:unload', function (e) {
    var root =
      e.target.querySelector('[data-hss]') ||
      (e.target.matches && e.target.matches('[data-hss]') ? e.target : null)
    if (root) unmount(root)
  })
})()
